<!-- Node Tree Content -->
<medsurf-design-content-template-node-tree #template_node_tree
  class="w-full">
  <!-- No Data Template -->
  <ng-template #no_data_template
    let-depth="depth">
    <div [class]="FlatModels.TreeDesignModels.TreeDragNode">
      <div [class]="FlatModels.TreeDesignModels.TreeDragNodeContent">
        <div [class]="FlatModels.TreeDesignModels.TreeDragNodeContentNoDataContainer(depth)">
          <span [class]="FlatModels.TreeDesignModels.TreeDragNodeNoDataText">
            {{ 'global.no_data' | translate }}
          </span>
        </div>
      </div>
    </div>
  </ng-template>

  <!-- Node Template -->
  <ng-template #override_node_template
    let-templateNodeTree="templateNodeTree"
    let-typedNodeExpanded="typedNodeExpanded"
    let-typedRouteElements="typedRouteElements"
    let-node="node"
    let-parentNode="parentNode"
    let-page="page"
    let-disabledParent="disabledParent">
    @if (page) {
      @if (typedRouteElements[node.id]; as routeElement) {
        <div [class]="FlatModels.TreeDesignModels.TreeDragNode"
          >
          @if ({
            selected: nodeSharedFacade.isNodeSelected$(node.id) | async,
            current: nodeSharedFacade.isNodeCurrent$(node.id) | async,
            hasBulkEditNode: nodeSharedFacade.hasBulkEditNode$(node.id) | async,
            routeElement: nodeSharedFacade.currentSelectedRouteElement$ | async
          }; as selectionData) {
            @if ({
              hasPermission: (appSharedFacade.canWriteNode$(node.id) | async) === true
            }; as permissionData) {
              <div
                [id]="'nt-' + node.id"
                [class]="FlatModels.TreeDesignModels.TreeDragNodeContent"
                [class.current]="!selectionData.hasBulkEditNode && routeElement.id === selectionData.routeElement?.id"
                [class.selected]="selectionData.selected"
                [class.disabled]="disabledParent || node.hidden === true"
                (click)="onNodeSelect($event, node, routeElement)">
                <div [class]="FlatModels.TreeDesignModels.TreeDragNodeContentHandleContainer">
                  <button medsurf-design-input-button [id]="'node_handle_' + node.id"
                    [title]="'global.drag_node' | translate"
                    [class]="FlatModels.TreeDesignModels.TreeDragNodeHandleElement"
                    [class.tree_hidden_element]="!selectionData.selected"
                    [class.opacity-0]="selectionData.hasBulkEditNode"
                    [inputClass]="FlatModels.ButtonDesignModels.ButtonDesignClass.HANDLE_TEXT"
                  [iconClass]="FlatModels.ButtonDesignModels.ButtonDefaultIcons.MOVE"></button>
                </div>
                <!--
                <div *ngIf="routeElement.depth > 0"
                  class="flex w-3rem">
                  <medsurf-design-input-checkbox [formField]="false"
                    *ngIf="{ hasBulkEditNode: nodeSharedFacade.hasBulkEditNode$(node.id) | async } as pageData"
                    [class]="'table-header-switch'"
                    [model]="pageData.hasBulkEditNode"
                    [name]="'node_select_all_' + node.id"
                  (valueChange)="onToggleBulkNode($event, node.id)"></medsurf-design-input-checkbox>
                </div>
                -->
                <div [class]="FlatModels.TreeDesignModels.TreeDragNodeContentDropDownContainer(routeElement.depth)">
                  @if (routeElement.depth < 4 && page.type !== FlatModels.PageEntityModels.PageType.enum.QuizStart && page.type !== FlatModels.PageEntityModels.PageType.enum.Vocabulary) {
                    <button medsurf-design-input-button
                      [id]="'node_toggle_' + node.id"
                      [title]="(!typedNodeExpanded[node.id] ? 'global.node_toggle_open' : 'global.node_toggle_close') | translate"
                      [inputClass]="FlatModels.ButtonDesignModels.ButtonDesignClass.SECONDARY_SMALL_TEXT"
                      [iconClass]="(!typedNodeExpanded[node.id] ? FlatModels.ButtonDesignModels.ButtonDefaultIcons.RIGHT : FlatModels.ButtonDesignModels.ButtonDefaultIcons.DOWN)"
                      [disabled]="node.children.length === 0"
                    (click)="templateNodeTree.onNodeExpand(node)"></button>
                  }
                </div>
                <div [class]="FlatModels.TreeDesignModels.TreeDragNodeContentImageContainer">
                  @if (page.type === FlatModels.PageEntityModels.PageType.enum.Slide && (slideAuthorFacade.media$(page.thumbnailMedia) | async); as media) {
                    <img [style]="FlatModels.TreeDesignModels.TreeDragNodeImageHeightStyle"
                      [src]="mediaControlService.getUrl(media, 'thumbnail') || '/assets/images/no-image.png'"
                      [alt]="media?.name || 'global.error_loading_image' | translate" />
                  }
                  @if (page.type !== FlatModels.PageEntityModels.PageType.enum.Slide || !page.thumbnailMedia) {
                    <i
                      [style.color]="FlatModels.ColorConfigModels.ThemeColorHexValue[page.themeColor] || page.themeColor"
                      class="{{ FlatModels.PageEntityModels.PageTypeAndDepthIcon(page.type, routeElement.depth) }} {{ page.themeColor?.length > 0 ? FlatModels.ButtonDesignModels.ButtonSolidStyle : '' }}">
                    </i>
                  }
                </div>
                <div [class]="FlatModels.TreeDesignModels.TreeDragNodeContentTitleContainer"
                  [style]="{'cursor': !selectionData.hasBulkEditNode && selectionData.selected && permissionData.hasPermission ? 'text' : 'pointer'}">
                  <span [id]="'node_' + node.id"
                    [class]="FlatModels.TreeDesignModels.TreeDragNodeContentText"
                    [title]="page.title">
                    {{ page.title }}
                  </span>

                </div>
                <div [class]="FlatModels.TreeDesignModels.TreeDragNodeContentAttributesContainer">
                  @if (node.hidden === true) {
                    <medsurf-design-content-chip
                      [tooltipLabel]="'global.node_not_visible' | translate"
                      [styleClass]="'p-menu_icon'">
                      <i [class]="FlatModels.ButtonDesignModels.ButtonDefaultIcons.EYE_SLASH"></i>
                    </medsurf-design-content-chip>
                  }
                </div>
                <div [class]="FlatModels.TreeDesignModels.TreeDragNodeContentAttributesContainer">
                  @if (node.restricted === true) {
                    <medsurf-design-content-chip
                      [tooltipLabel]="'global.node_is_restricted' | translate"
                      [styleClass]="'p-menu_icon'">
                      <i [class]="FlatModels.ButtonDesignModels.ButtonDefaultIcons.LOCK"></i>
                    </medsurf-design-content-chip>
                  }
                </div>
                @if (permissionData.hasPermission) {
                  <div
                    [class]="FlatModels.TreeDesignModels.TreeDragNodeContentOptionContainer">
                    @if (!selectionData.hasBulkEditNode) {
                      <medsurf-design-input-menu
                        [formField]="false"
                        [name]="'node_menu_' + node.id"
                        [tooltipLabel]="'global.node_menu' | translate"
                        [class.tree_hidden_element]="!selectionData.selected"
                        [buttonInputClass]="FlatModels.ButtonDesignModels.ButtonDesignClass.SECONDARY_SMALL_OUTLINED_TREE"
                        [iconOpen]="FlatModels.ButtonDesignModels.ButtonDefaultIcons.OPTIONS"
                        [iconClose]="FlatModels.ButtonDesignModels.ButtonDefaultIcons.OPTIONS"
                        [loadContext]="{type: 'node', routeElement, node, parentNode, page}"
                        [loadMenuItems]="getNodeMenuItems"
                      (click)="onNodeMenu(routeElement, node)"></medsurf-design-input-menu>
                    }
                    @if (![FlatModels.PageEntityModels.PageType.enum.Case, FlatModels.PageEntityModels.PageType.enum.Slide, FlatModels.PageEntityModels.PageType.enum.Training, FlatModels.PageEntityModels.PageType.enum.QuizStart, FlatModels.PageEntityModels.PageType.enum.Grid].includes(page.type)) {
                      <div
                        class="flex w-3rem justify-content-end">
                        <button medsurf-design-input-button [id]="'node_add_' + node.id"
                          [title]="getNodeMenuButtonTitleForTooltip(routeElement.depth)"
                          [class]="'w-full'"
                          [class.tree_hidden_element]="!selectionData.selected"
                          [class.opacity-0]="selectionData.hasBulkEditNode"
                          [inputClass]="FlatModels.ButtonDesignModels.ButtonDesignClass.SECONDARY_SMALL_OUTLINED_TREE"
                          [iconClass]="FlatModels.PageEntityModels.CreatePageTypeAndDepthIcon(page.type, routeElement.depth)"
                          [iconClassAfter]="FlatModels.ButtonDesignModels.ButtonDefaultIcons.ADD"
                        (click)="addNode(routeElement, node)"></button>
                      </div>
                    }
                    @if ([FlatModels.PageEntityModels.PageType.enum.Case, FlatModels.PageEntityModels.PageType.enum.Grid].includes(page.type)) {
                      <div
                        class="flex w-3rem justify-content-end">
                        <medsurf-design-input-menu [formField]="false"
                          [name]="'slide_menu_' + node.id"
                          [tooltipLabel]="'global.slide_add' | translate"
                          [class]="'w-full'"
                          [class.tree_hidden_element]="!selectionData.selected"
                          [class.opacity-0]="selectionData.hasBulkEditNode"
                          [buttonInputClass]="FlatModels.ButtonDesignModels.ButtonDesignClass.SECONDARY_SMALL_OUTLINED_TREE"
                          [buttonIconClass]="FlatModels.ButtonDesignModels.ButtonDefaultIcons.PAGE_SLIDE"
                          [loadContext]="{type: 'slide', routeElement, node}"
                          [loadMenuItems]="getSlideMenuItems"
                        (click)="handleEvent()"></medsurf-design-input-menu>
                      </div>
                    }
                  </div>
                }
              </div>
            }
            @if (![FlatModels.PageEntityModels.PageType.enum.Slide, FlatModels.PageEntityModels.PageType.enum.Training].includes(page.type)) {
              @if (nodeSharedFacade.nodeByIds$(node.children) | async | sortBy_shared:'asc':'position'; as childNodes) {
                <div [hidden]="!typedNodeExpanded[node.id]"
                  [class]="FlatModels.TreeDesignModels.TreeDragNodeContentContainer">
                  @if (node.children.length === 0) {
                  <ng-container *ngTemplateOutlet="no_data_template;context:{
                                depth: routeElement.depth + 3}"></ng-container>
                  }
                  @if (childNodes.length === 0) {
                    <!-- node.children is a string of ids -->
                    @for (i of node.children; track i) {
                      <p-skeleton [height]="FlatModels.TreeDesignModels.TreeDragNodeSkeletonHeight"
                        class="cursor-wait"
                      ></p-skeleton>
                    }
                  }
                  @if (childNodes.length > 0) {
                    <div
                      [dragula]="getDragulaKey('node-tree-' + (routeElement.depth + 1))"
                      [dragulaModel]="childNodes"
                      (dragulaModelChange)="onNodeMoved(node, $event)">
                      <ng-container *ngFor="let childNode of childNodes; trackBy: templateNodeTree.trackByNode">
                      <!-- @for (childNode of childNodes; track templateNodeTree.trackByNode($index, childNode)) { -->
                        <ng-container *ngTemplateOutlet="override_node_template;context:{
                                      templateNodeTree,
                                      typedNodeExpanded,
                                      typedRouteElements,
                                      parentNode: node,
                                      node: childNode,
                                      page: slideAuthorFacade.page$(childNode.page) | async,
                                      disabledParent: disabledParent || node.hidden === true}">
                        </ng-container>
                      </ng-container>
                    </div>
                  }
                </div>
              }
            }
          }
        </div>
      }
    }
  </ng-template>

  <!-- Menu Template -->
  <ng-template #override_menu_template
    let-templateNodeTree="templateNodeTree"
    let-typedNodeExpanded="typedNodeExpanded"
    let-typedRouteElements="typedRouteElements"
    let-elearnings="elearnings">
    <div [class]="FlatModels.TreeDesignModels.TreeDragulaNode"
      [dragula]="getDragulaKey('node-tree-0')"
      [dragulaModel]="elearnings"
      (dragulaModelChange)="onNodeMoved(null, $event)">
      <ng-container *ngFor="let elearning of elearnings; trackBy: templateNodeTree.trackByNode">
      <!-- @for (elearning of elearnings; track templateNodeTree.trackByNode($index, elearning)) { -->
        <ng-container *ngTemplateOutlet="override_node_template,context:{
                      templateNodeTree,
                      typedNodeExpanded,
                      typedRouteElements,
                      parentNode: undefined,
                      node: elearning,
                      page: slideAuthorFacade.page$(elearning.page) | async,
                      disabledParent: false}">
        </ng-container>
      </ng-container>
    </div>
  </ng-template>
</medsurf-design-content-template-node-tree>